import { useEffect } from "react";
import { setUtahHeaderSettings } from "@utahdts/utah-design-system-header";
import logo from "../../../images/DDW_LOGOS/Logo-DDW.svg";

function UtahHeader({
  providerUser,
  menuItemsArray,
  onSignIn,
  onSignOut,
}) {
  useEffect(() => {
    setUtahHeaderSettings({
      title: "Waterlink",
      utahId: {
        currentUser: providerUser?.user?.firstName
          ? {
              first: providerUser.user.firstName,
              last: providerUser.user.lastName,
              email: providerUser.user.email,
              authenticated: localStorage.getItem("auth") === "true",
            }
          : null,
        onSignIn,
        onSignOut,
        onProfile: () => {
          window.open("https://id.utah.gov", "_blank", "noopener,noreferrer");
        },
      },
      logo: {
        htmlString: '<img src="' + logo + '" id="ddw-logo" alt="Logo-DDW" />',
      },
      mainMenu: {
        menuItems: Array.isArray(menuItemsArray) ? menuItemsArray : [],
      },
      footer: {
        domLocationTarget: {
          cssSelector: "#app-footer",
        },
        showHorizontalRule: true,
      },
    });
  }, [providerUser, menuItemsArray, onSignIn, onSignOut]);

  return null;
}

export default UtahHeader;